import React from 'react';

const CategoryWidgets = () => {
    return (
        <>
            <div className="widget-archive">
                <h1>news catagorise</h1>
                <ul>
                    <li><a href="/#">Office Security<span>21</span></a></li>
                    <li><a href="/#">CCTV Security<span>31</span></a></li>
                    <li><a href="/#">House Security<span>41</span></a></li>
                    <li><a href="/#">Bank Security <span>15</span></a></li>
                    <li><a href="/#">Parking Security <span>20</span></a></li>
                    <li><a href="/#">Man Security <span>25</span></a></li>
                </ul>
            </div>
        </>
    );
};

export default CategoryWidgets;